import { AssistantLaunchRecord } from '../../../shared/models/revenue/AssistantLaunchReport';

export const uniqueLiveLocations = (records: AssistantLaunchRecord[]) => {
    const locations = new Map<string, AssistantLaunchRecord>();
    records.forEach((record, index) => {
        const organization = (record.organizationId || record.organizationName || record.organization || record.orgName || 'unassigned').trim().toLowerCase();
        const applicationName = (record.applicationName || record.name || '').trim();
        const normalizedName = applicationName
            .replace(/\s*\(manage menu\)\s*$/i, '')
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase();
        const key = normalizedName
            ? `${organization}|${normalizedName}`
            : record.applicationId || record.id || `${organization}|record-${index}`;
        const existing = locations.get(key);
        const existingIsManageMenu = /\(manage menu\)\s*$/i.test(existing?.applicationName || existing?.name || '');
        const currentIsManageMenu = /\(manage menu\)\s*$/i.test(applicationName);
        if (!existing || (existingIsManageMenu && !currentIsManageMenu)) locations.set(key, record);
    });
    return Array.from(locations.values());
};
